export default __webpack_public_path__ + "static/media/dots-more.e1c5eba9.svg";